import React, { useState, useEffect } from "react";
import { useField } from "formik";
import styles from "./DateTextFieldsSpread.module.scss";

import SetDateModal2 from "../../Modal/SetDateModal2";

const DateTextFields = ({ name, label, placeholder }) => {
  const [field, meta, helpers] = useField(name);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (field.value) {
      helpers.setTouched(true);
    }
  }, []);
  const openCloseFields = () => {
    if (isOpen) helpers.setTouched(true);
    setIsOpen(!isOpen);
  };
  const isTouchedError = meta.error && meta.touched;
  const isTouched = meta.touched;
  return (
    <>
      <div
        className={styles.DateTextFields}
        onClick={openCloseFields}
        data-invalid={isTouchedError}
      >
        <label
          className={styles.DateTextFields__placeholderLabel}
          data-touched={isTouched}
          data-invalid={isTouchedError}
        >
          {label}

        </label>

      </div>
      <div className={styles.dateModal}>
        <SetDateModal2 name={name} openCloseFields={openCloseFields} />
      </div>

    </>
  );
};

export default DateTextFields;
